/**
 * Practice runs in guides (#436). A teaching block (the backend's
 * `BlockSpec.practice`, served as `step.practice`) gets `practice` from its
 * step: its last action calls no API and calls `onCompleted` instead. The
 * guide then ticks the step, moves to the next screen (the end screen after
 * the last step) and shows this notice there, so the member knows nothing
 * happened for real.
 *
 * Members' English may be weak: keep the notices short and plain.
 */

/** Said after any practice run; a block may add what it teaches below. */
export const PRACTICE_TITLE = "This was a practice run";

const NOTICES: Partial<Record<string, string>> = {
  "meeting.find_room": "Nothing was booked. This is how you book a room.",
};

const DEFAULT_NOTICE = "Nothing was saved. This is how it works.";

/** The notice the guide shows after a practice run of `blockKey`. */
export function practiceNotice(blockKey: string): string {
  return (Object.prototype.hasOwnProperty.call(NOTICES, blockKey) && NOTICES[blockKey]) || DEFAULT_NOTICE;
}
